import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import RequireAuth from "./auth/RequireAuth";
import LoginPage from "./pages/LoginPage";
import MapPage from "./pages/MapPage";
import AlertsPage from "./pages/AlertsPage";
import MessagesPage from "./pages/MessagesPage";
import PanicPage from "./pages/PanicPage";
import ReassignPage from "./pages/ReassignPage";
import SchedulesPage from "./pages/SchedulesPage";
import StopTemplatesPage from "./pages/StopTemplatesPage";
import TripsPage from "./pages/TripsPage";
import MileagePage from "./pages/MileagePage";
import GtfsPage from "./pages/GtfsPage";
import UsersPage from "./pages/UsersPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import FirmwarePage from "./pages/FirmwarePage";
import DevicesPage from "./pages/DevicesPage";
import PIDDevicesPage from "./pages/PIDDevicesPage";
import PIDTickersPage from "./pages/PIDTickersPage";
import DashboardPage from "./pages/DashboardPage";

// A workbench for the simulation views, fed by a fixture instead of the API.
// Development builds only: the branch is constant-folded away in production,
// so neither the page nor the fixture is in the bundle.
const SimulationHarness = import.meta.env.DEV ? lazy(() => import("./dev/SimulationHarness")) : null;

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {SimulationHarness && (
        <Route path="/dev/simulation" element={<Suspense fallback={null}><SimulationHarness /></Suspense>} />
      )}
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        {/* /map shows the live realtime FleetMap (the persistent Layout
            backdrop); historical playback moved to /playback. */}
        <Route path="/map" element={<></>} />
        <Route path="/playback" element={<MapPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/panic" element={<PanicPage />} />
        <Route path="/reassign" element={<ReassignPage />} />
        <Route path="/trips" element={<TripsPage />} />
        <Route path="/mileage" element={<MileagePage />} />
        <Route path="/schedules" element={<SchedulesPage />} />
        <Route path="/stop-templates" element={<StopTemplatesPage />} />
        <Route path="/gtfs" element={<GtfsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/firmware" element={<FirmwarePage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/pid-devices" element={<PIDDevicesPage />} />
        <Route path="/pid-tickers" element={<PIDTickersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/users" element={<UsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
